import InputSeletorPerfil from './InputSeletorPerfil'

export default InputSeletorPerfil



// WEBPACK FOOTER //
// ./src/routes/admin/ConsultaPerfisAdmin/componentes/ConvidarPerfil/components/SeletorPerfil/index.js